import script from "./SharedButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedButton.vue?vue&type=script&setup=true&lang=ts"

import "./SharedButton.vue?vue&type=style&index=0&id=1ff5e09a&lang=scss"

const __exports__ = script;

export default __exports__